<div class="modal-header">
    <span *ngIf="!structureId" class="modal-header-title"> {{ 'ORGANIZATION.ADD_ORGANIZATION_STRUCTURE' | translate }}</span>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-12">
                <div class="form-group">
                    <label for="department"> {{ 'EMPLOEE.DEPARTMENT' | translate }}</label>
                    <ng-select  
                        id="department"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="department_id"
                        [loading]="loading"
                        [items]="departments"
                        >
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.department_id">
                            <div class="text-error" *ngIf="validation('department_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
            
            <div class="col-12">
                    
                <div class="form-group">
                    <label for="position"><span class="star">*</span> {{ 'EMPLOEE.POSITION' | translate }}</label>
                    <ng-select  
                        id="position"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="position_id"
                        [multiple] = "true"
                        [closeOnSelect]="false"
                        [loading]="loading"
                        [items]="positions"
                        >
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                                    <span>{{item.name}}</span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.product_id">
                            <div class="text-error" *ngIf="validation('position_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-sm" (click)="onCreate()"
        [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">{{ 'CLOSE' |
        translate}}</button>
</div>